import * as React from 'react';

const AppleBrandIcon = ({
  width = 22,
  height = 22,
  ...props
}: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none" {...props}>
    <g clipPath="url(#clipPath_AppleBrandIcon)">
      <path
        d="M18.0436 14.2032C17.5893 15.2108 17.3704 15.6607 16.7852 16.5517C15.969 17.7947 14.8162 19.3435 13.3895 19.3567C12.1223 19.3677 11.7967 18.5317 10.0752 18.5416C8.35476 18.5504 7.99616 19.3721 6.72786 19.36C5.30116 19.3468 4.20886 17.9487 3.39156 16.7046C1.10686 13.2286 0.868163 9.1476 2.27726 6.9773C3.27826 5.4362 4.85896 4.5342 6.34396 4.5342C7.85646 4.5342 8.80796 5.3636 10.0576 5.3636C11.2709 5.3636 12.0101 4.532 13.7591 4.532C15.0791 4.532 16.4805 5.2525 17.4782 6.4955C14.209 8.2874 14.7392 12.9558 18.0436 14.2032ZM12.4325 3.1438C13.0672 2.3276 13.5501 1.177 13.3752 0C12.3368 0.0715 11.1235 0.7315 10.414 1.5928C9.77156 2.3738 9.24026 3.5321 9.44596 4.6585C10.579 4.6926 11.7516 4.0161 12.4325 3.1438Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clipPath_AppleBrandIcon">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default AppleBrandIcon;
